import { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import { Grid, GridItem, Stack, TextArea } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { TextFormField } from './TextFormField'
import { UNLocodeFormTextField } from './UNLocodeFormTextField'
import { LocationFormData } from '../../schema'
import { AddressFormSelector } from '../AddressSelector/AddressFormSelector'

export const LocationForm: FC = () => {
  const { register } = useFormContext<LocationFormData>()
  const { translate } = useLocalisation()

  return (
    <Stack gap={16}>
      <AddressFormSelector
        name="address"
        label={translate('locations.search_address')}
        required={true}
        enableSanctionRiskCheck={true}
        sanctionRiskWarningMessage={translate('locations.search_address_form.sanction_risk_warning_message')}
      />
      <Grid gap={16} col={2} breakpoint="sm">
        <GridItem span={1}>
          <TextFormField name="locationName" label={translate('locations.location_name')} required={true} />
        </GridItem>
        <GridItem span={1}>
          <TextFormField name="companyName" label={translate('locations.company_name')} />
        </GridItem>
        <GridItem span={2}>
          <TextArea {...register('notes')} label={translate('locations.notes')} />
        </GridItem>
        <GridItem span={1}>
          <UNLocodeFormTextField name="unLocode" label={translate('locations.unLocode')} />
        </GridItem>
      </Grid>
    </Stack>
  )
}
